import React, { useState, useEffect } from 'react';
import './mapy.css';
import MapComponent from './map_component';
import '../kov/vybava';
import 'animate.css';
import { Container, Box } from '@mui/material';

const Dungeony = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const maps = [
    {
      nazev: "Brutální velitel",
      imgSrc: "./imgs/boss_1.png",
      imgIcon: "./imgs/boss_1.png",
      pozadi: "./imgs/dung_1.png",
      dostupneOd: "20 - 57",
      cekacidoba: "15",
      doporuceneBonusy: [
        { imgSrc: 'https://img.m2icondb.com/30255.png', text: 'Silný proti pololidem' },
        { imgSrc: 'https://img.m2icondb.com/30256.png', text: 'Obrana' }
      ],
      dropItems: [
        { imgSrc: './items/Shuriken.png', ks: '' },
        { imgSrc: './items/Úplňkový meč.png', ks: '+0' },
        { imgSrc: './items/Čepel z krevele.png', ks: '+0' },
        { imgSrc: './items/Černolistá dýka.png', ks: '+0' },
        { imgSrc: './items/Luk z parožiny.png', ks: '+0' },
        { imgSrc: './items/Vějíř podzimního větru.png', ks: '+0' },
        { imgSrc: './items/Starožitný zvon.png', ks: '+0' },
        { imgSrc: './items/Kniha misí (lehká).png', ks: '' },
        { imgSrc: './items/Požehnaný pergamen.png', ks: '3' },
        { imgSrc: './items/Rybí kůstky.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '' },
        { imgSrc: './items/Začarovat předmět.png', ks: '10' },
        { imgSrc: './items/Truhla Velitele.png', ks: '' },
        { imgSrc: './items/Magická koule (Velitel).png', ks: '' },
      ]
    },
    {
      nazev: "Vrchní Ork",
      imgSrc: "./imgs/boss_2.png",
      imgIcon: "./imgs/boss_2.png",
      pozadi: "./imgs/dung_2.png",
      dostupneOd: "40 - 65",
      cekacidoba: "30",
      doporuceneBonusy: [
        { imgSrc: 'https://img.m2icondb.com/30255.png', text: 'Silný proti orkům' },
        { imgSrc: 'https://img.m2icondb.com/30256.png', text: 'Obrana' }
      ],
      dropItems: [
        { imgSrc: './items/Zub Orka.png', ks: '' },
        { imgSrc: './items/Kniha misí (lehká).png', ks: '' },
        { imgSrc: './items/Požehnaný pergamen.png', ks: '5' },
        { imgSrc: './items/Rybí kůstky.png', ks: '2' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '2' },
        { imgSrc: './items/Začarovat předmět.png', ks: '15' },
        { imgSrc: './items/Truhla vrchního orka.png', ks: '' },
        { imgSrc: './items/Magická koule (Vrch. Ork).png', ks: '' },
        { imgSrc: './items/Fénické boty.png', ks: '+0' },
        { imgSrc: './items/Brnění dračího boha.png', ks: '+0' },
        { imgSrc: './items/Pancéřové brnění duše.png', ks: '+0' },
        { imgSrc: './items/Fuchsiový oblek.png', ks: '+0' },
        { imgSrc: './items/Oblečení baronky.png', ks: '+0' },
        { imgSrc: './items/Krvavý meč.png', ks: '+0' },
        { imgSrc: './items/Velký meč.png', ks: '+0' },
        { imgSrc: './items/Meč kouzelníka.png', ks: '+0' },
        { imgSrc: './items/Půlměsíční meč.png', ks: '+0' },
        { imgSrc: './items/Ledovcová píka.png', ks: '+0' },
        { imgSrc: './items/Meč Dvanáct duchů.png', ks: '+0' },
        { imgSrc: './items/Čepel spásy.png', ks: '+0' },
        { imgSrc: './items/Zabiják lvů.png', ks: '+0' },
        { imgSrc: './items/Dýka ďábelské pěsti.png', ks: '+0' },
        { imgSrc: './items/Krvavá dýka.png', ks: '+0' },
        { imgSrc: './items/Žebrovaný nůž.png', ks: '+0' },
        { imgSrc: './items/Chakram.png', ks: '+0' },
        { imgSrc: './items/Trnolistý luk.png', ks: '+0' },
        { imgSrc: './items/Luk z býčího rohu.png', ks: '+0' },
        { imgSrc: './items/Luk jednorožce.png', ks: '+0' },
        { imgSrc: './items/Luk s gigantickými křídly.png', ks: '+0' },
        { imgSrc: './items/Kouzelný zvon.png', ks: '+0' },
        { imgSrc: './items/Zvon zlatobrouka.png', ks: '+0' },
        { imgSrc: './items/Zvon ocelového brouka.png', ks: '+0' },
        { imgSrc: './items/Fénický vějíř.png', ks: '+0' },
        { imgSrc: './items/Trojitý vějíř.png', ks: '+0' },
        { imgSrc: './items/Vějíř obočí.png', ks: '+0' },
      ]
    },
    {
      nazev: "Pavoučí baronka",
      imgSrc: "./imgs/boss_3.png",
      imgIcon: "./imgs/boss_3.png",
      pozadi: "./imgs/dung_3.png",
      dostupneOd: "60 - 75",
      cekacidoba: "30",
      doporuceneBonusy: [
        { imgSrc: './items/Element_větru.png', text: 'Odolnost a sílá proti větru' },
        { imgSrc: 'https://img.m2icondb.com/30255.png', text: 'Silný proti zvířatům' },
      ],
      dropItems: [
        { imgSrc: './items/Pavoučí noha.png', ks: '' },
        { imgSrc: './items/Pavoučí vejce.png', ks: '' },
        { imgSrc: './items/Kniha misí (lehká).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Požehnaný pergamen.png', ks: '10' },
        { imgSrc: './items/Rybí kůstky.png', ks: '2' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '3' },
        { imgSrc: './items/Začarovat předmět.png', ks: '20' },
        { imgSrc: './items/Truhla baronky.png', ks: '' },
        { imgSrc: './items/Magická koule (Baronka).png', ks: '' },
        { imgSrc: './items/Bitevní meč.png', ks: '+0' },
        { imgSrc: './items/Ozubená čepel ducha.png', ks: '+0' },
        { imgSrc: './items/Dračí nůž.png', ks: '+0' },
        { imgSrc: './items/Velký žlutý dračí luk.png', ks: '+0' },
        { imgSrc: './items/Velká sudlice.png', ks: '+0' },
        { imgSrc: './items/Zvon nebe a země.png', ks: '+0' },
        { imgSrc: './items/Vějíř spásy.png', ks: '+0' },
        { imgSrc: './items/Sokolský štít.png', ks: '+0' },
        { imgSrc: './items/Tygří štít.png', ks: '+0' },
        { imgSrc: './items/Hranatý lví štít.png', ks: '+0' },
        { imgSrc: './items/Štít z dračích šupin.png', ks: '+0' },
        { imgSrc: './items/Maska strachu.png', ks: '+0' },
        { imgSrc: './items/Kukla orků.png', ks: '+0' },
        { imgSrc: './items/Helma s rohy.png', ks: '+0' },
        { imgSrc: './items/Kardinálský klobouk.png', ks: '+0' },
      ]
    },
    {
      nazev: "Morkhot",
      imgSrc: "./imgs/boss_4.png",
      imgIcon: "./imgs/boss_4.png",
      pozadi: "./imgs/dung_4.png",
      dostupneOd: "65 - 89",
      cekacidoba: "45",
      doporuceneBonusy: [
        { imgSrc: './items/Element_ledu.png', text: 'Odolnost a sílá proti ledu' },
        { imgSrc: 'https://img.m2icondb.com/30255.png', text: 'Silný proti ezoterikům' },
      ],
      dropItems: [
        { imgSrc: './items/Srdce Atlantídy.png', ks: '' },
        { imgSrc: './items/Kniha misí (standartní).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '4' },
        { imgSrc: './items/Začarovat předmět.png', ks: '30' },
        { imgSrc: './items/Truhla Atlantídy.png', ks: '' },
        { imgSrc: './items/Magický kámen.png', ks: '' },
        { imgSrc: './items/Magická koule (Morkhot).png', ks: '' },
        { imgSrc: './items/Jedovatý meč.png', ks: '+0' },
        { imgSrc: './items/Meč zášti.png', ks: '+0' },
        { imgSrc: './items/Ocelový luk vran.png', ks: '+0' },
        { imgSrc: './items/Chakram křídla ďábla.png', ks: '+0' },
        { imgSrc: './items/Zvon orchidejí.png', ks: '+0' },
        { imgSrc: './items/Brnění z černé oceli.png', ks: '+0' },
        { imgSrc: './items/Oblek černého větru.png', ks: '+0' },
        { imgSrc: './items/Brnění černé magie.png', ks: '+0' },
        { imgSrc: './items/Černé oblečení.png', ks: '+0' },
      ]
    },
    {
      nazev: "Azrael",
      imgSrc: "./imgs/boss_5.png",
      imgIcon: "./imgs/boss_5.png",
      pozadi: "./imgs/dung_5.png",
      dostupneOd: "75 - 104",
      cekacidoba: "60",
      doporuceneBonusy: [
        { imgSrc: './items/Element_temnoty.png', text: 'Odolnost a sílá proti temnotě' },
        { imgSrc: 'https://img.m2icondb.com/30255.png', text: 'Silný proti nemrtvým' },
      ],
      dropItems: [
        { imgSrc: './items/Kapka krve.png', ks: '' },
        { imgSrc: './items/Vejce Mini Azraela.png', ks: '' },
        { imgSrc: './items/Kniha misí (standartní).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '5' },
        { imgSrc: './items/Začarovat předmět.png', ks: '100' },
        { imgSrc: './items/Truhla Azraela.png', ks: '2' },
        { imgSrc: './items/Magický kámen.png', ks: '' },
        { imgSrc: './items/Magická koule (Azrael).png', ks: '' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Řetízek krystalu duše.png', ks: '+0' },
        { imgSrc: './items/Náramek krystalu duše.png', ks: '+0' },
        { imgSrc: './items/Náušnice krystalu duše.png', ks: '+0' },
      ]
    },
    {
      nazev: "Baren Setaou",
      imgSrc: "./imgs/boss_6.png",
      imgIcon: "./imgs/boss_6.png",
      pozadi: "./imgs/dung_6.png",
      dostupneOd: "75 - 104",
      cekacidoba: "60",
      doporuceneBonusy: [
        { imgSrc: './items/Element_blesku.png', text: 'Odolnost a sílá proti blesku' },
      ],
      dropItems: [
        { imgSrc: './items/Dračí šupiny.png', ks: '' },
        { imgSrc: './items/Vejce modrého draka.png', ks: '' },
        { imgSrc: './items/Kniha misí (standartní).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '50' },
        { imgSrc: './items/Začarovat předmět.png', ks: '150' },
        { imgSrc: './items/Truhla Beran-Setaou.png', ks: '2' },
        { imgSrc: './items/Truhla se svitky.png', ks: '' },
        { imgSrc: './items/Magický kámen.png', ks: '' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Magická koule (Beran).png', ks: '' },
        { imgSrc: './items/Ostnaté boty.png', ks: '+0' },
        { imgSrc: './items/Helma mistra války.png', ks: '+0' },
        { imgSrc: './items/Titánský štít.png', ks: '+0' },
      ]
    },
    {
      nazev: "Razador",
      imgSrc: "./imgs/boss_7.png",
      imgIcon: "./imgs/boss_7.png",
      pozadi: "./imgs/dung_7.png",
      dostupneOd: "90 - 110",
      cekacidoba: "60",
      doporuceneBonusy: [
        { imgSrc: './items/Element_ohně.png', text: 'Odolnost a sílá proti ohni' },
      ],
      dropItems: [
        { imgSrc: './items/Ohnivý kámen.png', ks: '' },
        { imgSrc: './items/Razadorovo vejce.png', ks: '' },
        { imgSrc: './items/Kniha misí (těžká).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '100' },
        { imgSrc: './items/Začarovat předmět.png', ks: '400' },
        { imgSrc: './items/Truhla Razadora.png', ks: '3' },
        { imgSrc: './items/Truhla se svitky.png', ks: '' },
        { imgSrc: './items/Magický kámen.png', ks: '' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Krystal (Vzácný).png', ks: '' },
        { imgSrc: './items/Plán zbroje.png', ks: '' },
        { imgSrc: './items/Kámen Rudého plamene.png', ks: '' },
        { imgSrc: './items/Magická koule (Razador).png', ks: '' },
      ]
    },
    {
      nazev: "Nemere",
      imgSrc: "./imgs/boss_8.png",
      imgIcon: "./imgs/boss_8.png",
      pozadi: "./imgs/dung_8.png",
      dostupneOd: "90 - 110",
      cekacidoba: "60",
      doporuceneBonusy: [
        { imgSrc: './items/Element_ledu.png', text: 'Odolnost a sílá proti ledu' },
      ],
      dropItems: [
        { imgSrc: './items/Ledový kámen.png', ks: '' },
        { imgSrc: './items/Nemerovo vejce.png', ks: '' },
        { imgSrc: './items/Kniha misí (těžká).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '100' },
        { imgSrc: './items/Začarovat předmět.png', ks: '400' },
        { imgSrc: './items/Truhla Nemere.png', ks: '3' },
        { imgSrc: './items/Truhla se svitky.png', ks: '' },
        { imgSrc: './items/Magický kámen.png', ks: '' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Krystal (Vzácný).png', ks: '' },
        { imgSrc: './items/Plán zbroje.png', ks: '' },
        { imgSrc: './items/Kámen Rudého plamene.png', ks: '' },
        { imgSrc: './items/Magická koule (Nemere).png', ks: '' },
      ]
    },
    {
      nazev: "Jotun Thrym",
      imgSrc: "./imgs/boss_9.png",
      imgIcon: "./imgs/boss_9.png",
      pozadi: "./imgs/dung_9.png",
      dostupneOd: "105 - 120",
      cekacidoba: "150",
      doporuceneBonusy: [
        { imgSrc: './items/Element_země.png', text: 'Odolnost a sílá proti zemi' },
        { imgSrc: './items/Element_větru.png', text: 'Odolnost a sílá proti větru' },
      ],
      dropItems: [
        { imgSrc: './items/Oxid titaničitý.png', ks: '' },
        { imgSrc: './items/Vejce Mini Exekutura.png', ks: '' },
        { imgSrc: './items/Kus šerpy.png', ks: '' },
        { imgSrc: './items/Kniha misí (těžká).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '200' },
        { imgSrc: './items/Začarovat předmět.png', ks: '600' },
        { imgSrc: './items/Truhla Jotun-Thryma.png', ks: '3' },
        { imgSrc: './items/Truhla se svitky.png', ks: '2' },
        { imgSrc: './items/Magický kámen.png', ks: '2' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Krystal (Vzácný).png', ks: '' },
        { imgSrc: './items/Krystal (Epický).png', ks: '' },
        { imgSrc: './items/Plán zbroje.png', ks: '' },
        { imgSrc: './items/Kámen Rudého plamene.png', ks: '' },
        { imgSrc: './items/Magická koule (Jotun).png', ks: '' },
      ]
    },
    {
      nazev: "Hydra",
      imgSrc: "./imgs/boss_10.png",
      imgIcon: "./imgs/boss_10.png",
      pozadi: "./imgs/dung_10.png",
      dostupneOd: "105 - 120",
      cekacidoba: "150",
      doporuceneBonusy: [
        { imgSrc: './items/Element_ledu.png', text: 'Odolnost a sílá proti ledu' },
        { imgSrc: './items/Element_blesku.png', text: 'Odolnost a sílá proti blesku' },
      ],
      dropItems: [
        { imgSrc: './items/Šupiny Hydry.png', ks: '' },
        { imgSrc: './items/Vejce Mini Nessie.png', ks: '' },
        { imgSrc: './items/Kniha misí (těžká).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '200' },
        { imgSrc: './items/Začarovat předmět.png', ks: '600' },
        { imgSrc: './items/Truhla Hydry.png', ks: '3' },
        { imgSrc: './items/Truhla se svitky.png', ks: '2' },
        { imgSrc: './items/Magický kámen.png', ks: '2' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Krystal (Vzácný).png', ks: '' },
        { imgSrc: './items/Krystal (Epický).png', ks: '' },
        { imgSrc: './items/Plán zbroje.png', ks: '' },
        { imgSrc: './items/Kámen Rudého plamene.png', ks: '' },
        { imgSrc: './items/Magická koule (Hydra).png', ks: '' },
        { imgSrc: './items/Rukavice (SIL).png', ks: '+0' },
        { imgSrc: './items/Rukavice (INT).png', ks: '+0' },
        { imgSrc: './items/Rukavice (POH).png', ks: '+0' },
        { imgSrc: './items/Rukavice (VIT).png', ks: '+0' },
      ]
    },
    {
      nazev: "Garm",
      imgSrc: "./imgs/boss_11.png",
      imgIcon: "./imgs/boss_11.png",
      pozadi: "./imgs/dung_11.png",
      dostupneOd: "105 - 120",
      cekacidoba: "150",
      doporuceneBonusy: [
        { imgSrc: './items/Element_země.png', text: 'Odolnost a sílá proti zemi' },
      ],
      dropItems: [
        { imgSrc: './items/Ztracený list.png', ks: '' },
        { imgSrc: './items/Vejce Baby Baashida.png', ks: '' },
        { imgSrc: './items/Kniha misí (těžká).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '200' },
        { imgSrc: './items/Začarovat předmět.png', ks: '600' },
        { imgSrc: './items/Truhla zvěrokruhu.png', ks: '3' },
        { imgSrc: './items/Truhla se svitky.png', ks: '2' },
        { imgSrc: './items/Magický kámen.png', ks: '2' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Krystal (Vzácný).png', ks: '' },
        { imgSrc: './items/Krystal (Epický).png', ks: '' },
        { imgSrc: './items/Plán zbroje.png', ks: '' },
        { imgSrc: './items/Kámen Rudého plamene.png', ks: '' },
        { imgSrc: './items/Magická koule (Garm).png', ks: '' },
        { imgSrc: './items/Meč Zvěrokruhu.png', ks: '+0' },
        { imgSrc: './items/Halapartna Zvěrokruhu.png', ks: '+0' },
        { imgSrc: './items/Dýka Zvěrokruhu.png', ks: '+0' },
        { imgSrc: './items/Luk Zvěrokruhu.png', ks: '+0' },
        { imgSrc: './items/Zvon Zvěrokruhu.png', ks: '+0' },
        { imgSrc: './items/Vějíř Zvěrokruhu.png', ks: '+0' },
      ]
    },
    {
      nazev: "Kostilivý drak",
      imgSrc: "./imgs/boss_12.png",
      imgIcon: "./imgs/boss_12.png",
      pozadi: "./imgs/dung_12.png",
      dostupneOd: "110 - 120 [SKUPINOVÝ]",
      cekacidoba: "320",
      doporuceneBonusy: [
        { imgSrc: './items/Element_temnoty.png', text: 'Odolnost a sílá proti temnotě' },
        { imgSrc: './items/Element_ohně.png', text: 'Odolnost a sílá proti ohni' },
        { imgSrc: 'https://img.m2icondb.com/50289.png', text: 'Odol. proti poš. schopností' },
      ],
      dropItems: [
        { imgSrc: './items/Skeletoní lebka.png', ks: '3' },
        { imgSrc: './items/Kniha misí (těžká).png', ks: '3' },
        { imgSrc: './items/Jitrocel.png', ks: '15' },
        { imgSrc: './items/Mandragora.png', ks: '3' },
        { imgSrc: './items/Cor Draconis (legend.).png', ks: '10' },
        { imgSrc: './items/Začarovat předmět.png', ks: '9000' },
        { imgSrc: './items/Truhla Kostlivého draka.png', ks: '15' },
        { imgSrc: './items/Magický kámen.png', ks: '6' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Krystal (Vzácný).png', ks: '' },
        { imgSrc: './items/Krystal (Epický).png', ks: '' },
        { imgSrc: './items/Krystal (Legendární).png', ks: '' },
        { imgSrc: './items/Plán zbroje.png', ks: '15' },
        { imgSrc: './items/Kámen Rudého plamene.png', ks: '3' },
        { imgSrc: './items/Magická koule (Kostlivý drak).png', ks: '' },
        { imgSrc: './items/Božské ovoce.png', ks: '30' },
      ]
    },
    {
      nazev: "Wukong",
      imgSrc: "./imgs/boss_13.png",
      imgIcon: "./imgs/boss_13.png",
      pozadi: "./imgs/dung_13.png",
      dostupneOd: "115 - 120",
      cekacidoba: "240",
      doporuceneBonusy: [
        { imgSrc: './items/Element_větru.png', text: 'Odolnost a sílá proti větru' },
        { imgSrc: './items/Element_ohně.png', text: 'Odolnost a sílá proti ohni' },
        { imgSrc: 'https://img.m2icondb.com/50289.png', text: 'Odol. proti poš. schopností' },
        { imgSrc: 'https://img.m2icondb.com/30255.png', text: 'Silný proti zvířatům' },
      ],
      dropItems: [
        { imgSrc: './items/Fénixův prapor.png', ks: '' },
        { imgSrc: './items/Kniha misí (expert).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '200' },
        { imgSrc: './items/Cor Draconis (mýtický).png', ks: '' },
        { imgSrc: './items/Začarovat předmět.png', ks: '1800' },
        { imgSrc: './items/Truhla Wukonga.png', ks: '5' },
        { imgSrc: './items/Truhla se svitky.png', ks: '2' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Krystal (Vzácný).png', ks: '' },
        { imgSrc: './items/Krystal (Epický).png', ks: '' },
        { imgSrc: './items/Krystal (Legendární).png', ks: '' },
        { imgSrc: './items/Plán zbroje.png', ks: '2' },
        { imgSrc: './items/Kámen Rudého plamene.png', ks: '' },
        { imgSrc: './items/Magická koule (Wukong).png', ks: '' },
        { imgSrc: './items/Prut zlata (2 mil. Yang).png', ks: '75' },
      ]
    },
    {
      nazev: "Džin",
      imgSrc: "./imgs/boss_14.png",
      imgIcon: "./imgs/boss_14.png",
      pozadi: "./imgs/dung_14.png",
      dostupneOd: "115 - 120",
      cekacidoba: "240",
      doporuceneBonusy: [
        { imgSrc: './items/Element_země.png', text: 'Odolnost a sílá proti zemi' },
        { imgSrc: './items/Element_blesku.png', text: 'Odolnost a sílá proti blesku' },
        { imgSrc: 'https://img.m2icondb.com/50289.png', text: 'Odol. proti poš. schopností' },
        { imgSrc: 'https://img.m2icondb.com/30255.png', text: 'Silný proti nemrtvým' },
      ],
      dropItems: [
        { imgSrc: './items/Světlo z jiného světa.png', ks: '' },
        { imgSrc: './items/Kniha misí (expert).png', ks: '' },
        { imgSrc: './items/Jitrocel.png', ks: '5' },
        { imgSrc: './items/Mandragora.png', ks: '' },
        { imgSrc: './items/Cor Draconis (surové).png', ks: '200' },
        { imgSrc: './items/Cor Draconis (mýtický).png', ks: '' },
        { imgSrc: './items/Začarovat předmět.png', ks: '1800' },
        { imgSrc: './items/Truhla Džina.png', ks: '5' },
        { imgSrc: './items/Truhla se svitky.png', ks: '2' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Krystal (Vzácný).png', ks: '' },
        { imgSrc: './items/Krystal (Epický).png', ks: '' },
        { imgSrc: './items/Krystal (Legendární).png', ks: '' },
        { imgSrc: './items/Plán zbroje.png', ks: '2' },
        { imgSrc: './items/Kámen Rudého plamene.png', ks: '' },
        { imgSrc: './items/Magická koule (Džin).png', ks: '' },
        { imgSrc: './items/Prut zlata (2 mil. Yang).png', ks: '100' },
        { imgSrc: './items/Truhla požehnání.png', ks: '' },
        { imgSrc: './items/Hadí kamizola (výroba).png', ks: '' },
        { imgSrc: './items/Hadí vesta (výroba).png', ks: '' },
        { imgSrc: './items/Kam. zlého hada (výroba).png', ks: '' },
        { imgSrc: './items/Č. Hadí kamiz. (výroba).png', ks: '' },
        { imgSrc: './items/Hadí meč (výroba).png', ks: '' },
        { imgSrc: './items/Hadí dýka (výroba).png', ks: '' },
        { imgSrc: './items/Hadí luk (výroba).png', ks: '' },
        { imgSrc: './items/Hadí velký meč (výroba).png', ks: '' },
        { imgSrc: './items/Hadí zvon (výroba).png', ks: '' },
        { imgSrc: './items/Hadí vějíř (výroba).png', ks: '' },
      ]
    },
    {
      nazev: "Alastor",
      imgSrc: "./imgs/boss_15.png",
      imgIcon: "./imgs/boss_15.png",
      pozadi: "./imgs/dung_15.png",
      dostupneOd: "120",
      cekacidoba: "150",
      doporuceneBonusy: [
        { imgSrc: './items/Element_ledu.png', text: 'Odolnost a sílá proti ledu' },
        { imgSrc: './items/Element_blesku.png', text: 'Odolnost a sílá proti blesku' },
        { imgSrc: 'https://img.m2icondb.com/50289.png', text: 'Odol. proti poš. schopností' },
        { imgSrc: 'https://img.m2icondb.com/30255.png', text: 'Průraznost Alastora' },
        { imgSrc: 'https://img.m2icondb.com/30256.png', text: 'Odolnost u Alastora' },
      ],
      dropItems: [
        { imgSrc: './items/Alastorova duše.png', ks: '' },
        { imgSrc: './items/Truhla Alastora.png', ks: '' },
        { imgSrc: './items/Vejce bílého draka.png', ks: '' },
        { imgSrc: './items/Kniha misí (expert).png', ks: '' },
        { imgSrc: './items/Elixír Alastora.png', ks: '' },
        { imgSrc: './items/Truhla se svitky.png', ks: '2' },
        { imgSrc: './items/Začarovat předmět.png', ks: '1800' },
        { imgSrc: './items/Cor Draconis (ametyst).png', ks: '15-20' },
        { imgSrc: './items/Krystal (Neobvyklý).png', ks: '' },
        { imgSrc: './items/Krystal (Vzácný).png', ks: '' },
        { imgSrc: './items/Krystal (Epický).png', ks: '' },
        { imgSrc: './items/Krystal (Legendární).png', ks: '' },
        { imgSrc: './items/Magická koule (Alastor).png', ks: '' },
        { imgSrc: './items/Prut zlata (2 mil. Yang).png', ks: '2500' },
        { imgSrc: './items/Elixír lapidis (100 procent).png', ks: '' },
      ]
    },
  ];

  const switchMap = (index) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    const detailElement = document.querySelector('.celek');
    if (detailElement) {
      detailElement.classList.remove('animate__animated');
      void detailElement.offsetWidth;
      detailElement.classList.add('animate__animated');
    }
  }, [activeIndex]);

  return (
    <Container className='maindung'>
    <div>
      <Box className="vedle">
        {maps.map((map, index) => (
          <div key={index} className={`boxik velikost ${index === activeIndex ? 'selected' : ''}`} onClick={() => switchMap(index)}>
            <div className='fixik'>
              <img src={map.imgIcon} alt={map.nazev} className={`mapaboss boss_${index + 1}`} />
            </div>
          </div>
        ))}
      </Box>
  <MapComponent {...maps[activeIndex]} />
    </div>
    </Container>
  );
};

export default Dungeony;
